import {
  ITabelFieldViewProps,
  ITableFields,
  TABLE_FIELD_ALIGN,
  TABLE_FIELD_TYPE,
} from "../../core-component/ui/ICTable";
import { IPagination } from "../../data/AppInterface";
import {
  TReactSetState,
  TSetPaginationFn,
  TUseTranslationTfn,
} from "../../data/AppType";
import {
  DELETE_TAX_COMPONENT,
  GET_ALL_TAX_COMPONENTS,
} from "../../services/Endpoints";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import {
  handleError,
  sweetAlertError,
  sweetAlertSuccess,
} from "../../utils/AppFunctions";

export interface ITaxComponents {
  id: string;
  name: string;
  rate: number;
  category_name: string;
  created_by: string;
  created_date: string;
  modified_by: string | null;
  modified_date: string | null;
}
export interface ITaxComponentsAdvancedSearch {
  taxCategory: number | null;
}
export const TAX_CATEGORY_ADVANCE_SEARCH_INITIAL_VALUE = {
  taxCategory: null,
};

export function getTaxComponentsFields<T>(
  actionComponent: (item: T) => JSX.Element,
  t: TUseTranslationTfn
): ITableFields<T>[] {
  return [
    {
      name: t("name"),
      key: "name",
      sort: true,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-2",
    },
    {
      name: t("category_name"),
      key: "category_name",
      sort: true,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-2",
    },
    {
      name: t("rate_percentage"),
      key: "rate",
      sort: true,
      type: TABLE_FIELD_TYPE.format,
      align: TABLE_FIELD_ALIGN.right,
      flex: "col-span-1",
      format: ({ field, data }: ITabelFieldViewProps<T>) =>
        data["rate"] ? data["rate"] + "%" : "-",
    },
    {
      name: t("created_date"),
      key: "created_date",
      sort: true,
      type: TABLE_FIELD_TYPE.date,
      align: TABLE_FIELD_ALIGN.center,
      flex: "col-span-2",
    },
    {
      name: t("created_by"),
      key: "created_by",
      sort: false,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-2",
    },
    {
      name: t("modified_date"),
      key: "modified_date",
      sort: true,
      type: TABLE_FIELD_TYPE.date,
      align: TABLE_FIELD_ALIGN.center,
      flex: "col-span-2",
    },
    {
      name: t("modified_by"),
      key: "modified_by",
      sort: false,
      type: TABLE_FIELD_TYPE.text,
      align: TABLE_FIELD_ALIGN.left,
      flex: "col-span-2",
    },

    {
      name: t("action"),
      key: "action",
      sort: false,
      type: TABLE_FIELD_TYPE.custom,
      align: TABLE_FIELD_ALIGN.center,

      flex: "col-span-1",
      component: actionComponent,
    },
  ];
}

export const getAllTaxComponents = async (
  setTaxComponents: TReactSetState<ITaxComponents[]>,
  pagination: IPagination,
  setPagination: TSetPaginationFn,
  search: string,
  advanceSearch: ITaxComponentsAdvancedSearch
) => {
  try {
    const taxComponentField = await GET_ALL_TAX_COMPONENTS(
      pagination,
      search,
      advanceSearch
    );
    if (
      taxComponentField &&
      taxComponentField.code === DEFAULT_STATUS_CODE_SUCCESS
    ) {
      setTaxComponents(taxComponentField.data.items);
      setPagination(taxComponentField.data.pagination);
    } else {
      setTaxComponents([]);
      sweetAlertError({
        message: taxComponentField.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
    }
  } catch (error: any) {
    handleError(error, "getAllTaxComponents");
  }
};

export const deleteTaxComponentField = async (id: string) => {
  try {
    const deletedData = await DELETE_TAX_COMPONENT(id);
    if (deletedData && deletedData.code === DEFAULT_STATUS_CODE_SUCCESS) {
      sweetAlertSuccess({ message: deletedData.message });
      return true;
    } else {
      sweetAlertError({
        message: deletedData.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
      return false;
    }
  } catch (e: any) {
    handleError(e, "deleteTaxComponentField");
    return false;
  }
};
